import { msg } from "@lingui/core/macro";

export const startTimeIsNotInPastRuleMessages = {
	name: msg({ message: "Start Time is not in the past" }),
	description: msg({ message: "Start Time is not in the past" }),
	errors: {
		startAfterEnd: msg({ message: "Start time cannot be after end time" }),
		startTimeInPastOnUpdate: msg({ message: "Start time cannot be in the past" }),
	},
} as const;
